import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ERole, INav } from 'src/app/common/model/nav.model';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  private triggerMenuUpdate = new Subject<void>();
  trigger$ = this.triggerMenuUpdate.asObservable();
  updateMenuItems(): void {
    this.triggerMenuUpdate.next();
  }

  constructor(private httpClient: HttpClient) {}

  getAllAdminNavItems(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(
      `${environment.api_url}menu/admin/all`
    );
  }

  generateDefaultMenu(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(
      `${environment.api_url}menu/admin/reset`
    );
  }
  ////login in as system admin
  recreateMenuDefault(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(
      `${environment.api_url}menu/admin/recreateMenuDefault`
    );
  }

  assignRole<T>(updatedRole: T): Observable<ISibasiHTTPResponse<T>> {
    return this.httpClient.post<ISibasiHTTPResponse<T>>(
      `${environment.api_url}menu/admin/assignRole`,
      updatedRole
    );
  }

  unAssignRole<T>(updatedRole: T): Observable<ISibasiHTTPResponse<T>> {
    return this.httpClient.post<ISibasiHTTPResponse<T>>(
      `${environment.api_url}menu/admin/removeRole`,
      updatedRole
    );
  }
  resetMenu(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(
      `${environment.api_url}menu/admin/reset`
    );
  }

  getAllNavItems(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(
      `${environment.api_url}menu/admin/allMenuItems`
    );
  }

  getNavItemsByRoles(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(`${environment.api_url}menu`);
  }
  getNavLicensedItemsByRoles(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(
      `${environment.api_url}menu/licensed`
    );
  }

  createNavItem(navItem: INav): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav>>(
      `${environment.api_url}menu/admin/addMenuItem`,
      navItem
    );
  }

  createNavItems(navItems: INav[]): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav>>(
      `${environment.api_url}menu/admin/createMany`,
      navItems
    );
  }

  deleteNavItem(navItemId: string): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.delete<ISibasiHTTPResponse<INav>>(
      `${environment.api_url}menu/admin/delete/${navItemId}`
    );
  }

  deleteAllNavItems(): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.delete<ISibasiHTTPResponse<INav>>(
      `${environment.api_url}menu/admin/delete/all`
    );
  }

  assignNavItemRole(
    navItemId: string,
    role: ERole
  ): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav>>(
      `${environment.api_url}menu/admin/${navItemId}/assignRole`,
      { role }
    );
  }

  unAssignNavItemRole(
    navItemId: string,
    role: ERole
  ): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav>>(
      `${environment.api_url}menu/admin/${navItemId}/removeRole`,
      { role }
    );
  }

  recreateDefaultMenu(): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav>>(
      `${environment.api_url}admin/menu/admin/recreateMenuDefault`
    );
  }
}
